import { Button } from "@/components/ui/Button/Button";
import { DashboardCard } from "@/components/ui/DashboardCard/DashboardCard";
import { HStack } from "@/components/layout/HStack";
import { VStack } from "@/components/layout/VStack";
import { Download } from "lucide-react";
import type { ReactNode } from "react";

type ExportCardProps = {
  title: string;
  description: string;
  buttonLabel: string;
  loading: boolean;
  disabled?: boolean;
  onDownload: () => void;
  children?: ReactNode;
};

const ExportCard = ({
  title,
  description,
  buttonLabel,
  loading,
  disabled,
  onDownload,
  children,
}: ExportCardProps) => {
  return (
    <DashboardCard gap="var(--space-sm)">
      <VStack gap="var(--space-3xs)">
        <h3
          style={{
            fontSize: "var(--text-lg)",
            lineHeight: "var(--line-height-lg)",
            fontWeight: "var(--font-semibold)",
          }}
        >
          {title}
        </h3>
        <p style={{ color: "var(--muted-foreground)" }}>{description}</p>
      </VStack>
      {children && <div>{children}</div>}
      <HStack justify="flex-end">
        <Button
          variant="primary"
          onClick={onDownload}
          disabled={loading || disabled}
        >
          <Download size={16} />
          {loading ? "Downloading..." : buttonLabel}
        </Button>
      </HStack>
    </DashboardCard>
  );
};

export { ExportCard };
